import * as React from 'react';
import type { SxProps, Theme } from '@mui/material'
import { Chip, type ChipProps } from '@workwave-tidal/core/components'
import { useConversationEditor } from '../ConversationEditorProvider.js'
import { INSERT_SUGGESTION_COMMAND } from './useInsertSuggestion.js'

export type ConversationSuggestionProps = {
  /**
   * The text of the suggestion chip
   */
  label: string
  /**
   * The suggestion applied to the editor
   */
  suggestion: string
  /**
   * data-testid used for the root Stack component
   */
  testId?: string
  /**
   * additional class name to pass to the root Stack component
   */
  className?: string
  /**
   * allows to pass additional styles to the root Stack component
   */
  sx?: SxProps<Theme>

  slotProps?: {
    chip?: Partial<ChipProps>
  }
}

export function ConversationSuggestion(props: ConversationSuggestionProps) {
  const {
    sx,
    className,
    testId = 'TidalConversationSuggestion',
    label,
    suggestion,
    slotProps: { chip } = {},
  } = props

  // ATTENTION: we use the internal hook instead of `useLexicalComposerContext`
  // because we want to be able to use it in any descendant of the Conversation component
  const editor = useConversationEditor()

  function onClick() {
    editor?.dispatchCommand(INSERT_SUGGESTION_COMMAND, suggestion)
  }

  return (
    <Chip
      {...chip}
      sx={{
        '&:hover': {
          // ATTENTION: This won't work with dark theme
          color: t => t.vars.palette.common.white,
        },
        ...sx,
      }}
      color="primary"
      label={label}
      variant="filledOutline"
      clickable
      className={className}
      onClick={onClick}
      data-tidal="ConversationSuggestion"
      data-testid={testId}
      size="small"
    />
  )
}
